import { type AnalysisClientItem, AnalysisClientItemRelationType } from "Infrastructure/ApiZfp/Schema";

export type PersonPickerPerson = {
  readonly value: string;
  readonly firstName: string;
  readonly surname: string;
  readonly birthDate?: string | null;
  readonly isMainClient: boolean;
};

/** The main client goes first, everyone else keeps the order they came in. */
export const toPersonPickerPersons = (clients: AnalysisClientItem[]): PersonPickerPerson[] =>
  clients
    .map((client) => ({
      value: client.guid,
      firstName: client.firstName,
      surname: client.surname,
      birthDate: client.birthDate,
      isMainClient: client.relationType === AnalysisClientItemRelationType.Client,
    }))
    .sort((a, b) => Number(b.isMainClient) - Number(a.isMainClient));
